import React from 'react';
import { inject, observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

export const Transition = React.forwardRef((props, ref) => (
  <Slide direction='up' {...props} ref={ref} />
))

@inject("CommonStore")
@observer
class DialogBox extends React.Component {

  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleApiCall = this.handleApiCall.bind(this);
  };

  render() {
    let store = this.props.CommonStore.dialogBox;
    return (
      <div>
        {store.showDialog &&
          <Dialog
            open={store.showDialog}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            disableBackdropClick={store.showDialog}
            TransitionComponent={Transition}
          >
            <DialogTitle id="alert-dialog-title" style={{ backgroundColor: '#EA6F0B' }}>
              <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#fff' }}>{store.title}</span>
            </DialogTitle>
            <DialogContent style={{ marginTop: '10px' }}>
              <DialogContentText id="alert-dialog-description" style={{ fontSize: '16px', color: 'black', fontWeight: 'normal' }}>
                {store.body}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button style={{ fontSize: '14px', color: '#fff', backgroundColor: '#EA6F0B' }} onClick={this.handleClose} color="primary">
                No
              </Button>
              <Button style={{ fontSize: '14px', color: '#fff', backgroundColor: 'red' }} onClick={this.handleApiCall.bind(this)} color="primary" autoFocus>
                Yes
              </Button>
            </DialogActions>
          </Dialog>}
      </div>
    );
  };

  /**
   * Method to handle close of dialog box
   */
  handleClose = () => {
    this.props.CommonStore.dialogBox.showDialog = false;
    if (this.props.CommonStore.showLoader)
      this.props.CommonStore.toggleLoader();
  };

  /**
   * Method to handle dialog for api calls
   */
  handleApiCall() {
    this.props.CommonStore.dialogBox.showDialog = false;
    this.props.CommonStore.callEndPoint();
  };
};

export default DialogBox;
